import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { postTimeOpen, fetchTimeOpenStatus, postTimeFinalize, postTimeExtend } from '../actions/qrstime'
import { postRedsys, fetchCustomer } from '../actions/qrstime'
import { LockKeyhole, LockKeyholeOpen, LogOut, Clock, Phone, KeyRound, CalendarClock, Timer } from 'lucide-react'

class TimeOpenView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // From location.state
      lockerData: null,
      rentalData: null,
      machineData: null,
      timeConfig: null,
      // Pricing
      qrType: 'pay',
      ticketIVA: '21',
      lockerCustomerID: null,
      prices: [],
      phoneNumber: '',
      accessCode: '',
      qrToken: '',
      // UI states
      showOpenOptions: false,
      isOpening: false,
      isOpened: false,
      openError: false,
      isFinalizing: false,
      isFinalized: false,
      // Countdown for open action
      minutes: 5,
      seconds: 0,
      // Time display countdown
      timeRemainingMinutes: 0,
      isExpired: false,
      // Buy more time
      showExtendModal: false,
      extendSlotMinutes: null,
      isExtending: false,
      extendSuccess: false,
      // Extend payment
      showExtendPayment: false,
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      redsysAction: null,
      isProcessingPayment: false,
    }

    this.redsysFormRef = React.createRef();
    this.timeRemainingInterval = null;
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  componentDidMount() {
    const { lockerData, rentalData, machineData, timeConfig, pricing, phoneNumber, accessCode, qrToken } = this.props.location.state;

    this.setState({
      lockerData,
      rentalData,
      machineData,
      timeConfig: timeConfig || null,
      qrType: pricing?.qrType || 'pay',
      ticketIVA: pricing?.ticketIVA || '21',
      lockerCustomerID: pricing?.lockerCustomerID || null,
      prices: pricing?.prices || [],
      phoneNumber,
      accessCode,
      qrToken,
      timeRemainingMinutes: rentalData.timeRemainingMinutes,
      isExpired: rentalData.isExpired,
    });

    // Update time remaining every minute
    this.timeRemainingInterval = setInterval(() => {
      this.setState(prev => {
        const newRemaining = Math.max(0, prev.timeRemainingMinutes - 1);
        return {
          timeRemainingMinutes: newRemaining,
          isExpired: newRemaining <= 0,
        };
      });
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.timeRemainingInterval);
    clearInterval(this.countdownInterval);
    clearInterval(this.statusInterval);
  }

  formatExtendDuration(minutes) {
    if (!minutes) return '--';
    if (minutes >= 1440) return `${minutes / 60}h`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0) return `${m} min`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}min`;
  }

  formatExtendDuration(minutes) {
    if (!minutes) return '--';
    if (minutes >= 1440) return `${minutes / 60}h`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0) return `${m} min`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}min`;
  }

  formatTimeRemaining() {
    const { timeRemainingMinutes } = this.state;
    const hours = Math.floor(timeRemainingMinutes / 60);
    const mins = timeRemainingMinutes % 60;
    if (hours > 0) return `${hours}h ${mins}min`;
    return `${mins} min`;
  }

  formatRentedTime() {
    const { rentalData } = this.state;
    if (!rentalData) return '--';
    const totalMinutes = rentalData.rentedMinutes;
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    if (hours > 0) return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
    return `${mins} min`;
  }

  startOpenCountdown = () => {
    this.setState({ minutes: 5, seconds: 0 });
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState(prev => ({ seconds: prev.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState(prev => ({ minutes: prev.minutes - 1, seconds: 59 }));
        } else {
          clearInterval(this.countdownInterval);
        }
      }
    }, 1000);
  }

  pollOpenStatus = (remoteActionId, onComplete) => {
    this.statusInterval = setInterval(() => {
      this.props.fetchTimeOpenStatus(remoteActionId)
        .then((answer) => {
          if (answer.response.status === 'COMPLETE' || answer.response.status === 'ONPROCESS') {
            clearInterval(this.statusInterval);
            clearInterval(this.countdownInterval);
            onComplete(true);
          } else if (answer.response.status === 'ERROR') {
            clearInterval(this.statusInterval);
            clearInterval(this.countdownInterval);
            onComplete(false);
          }
        })
        .catch(() => {
          clearInterval(this.statusInterval);
          clearInterval(this.countdownInterval);
          onComplete(false);
        });
    }, 5000);

    setTimeout(() => {
      if (this.statusInterval) {
        clearInterval(this.statusInterval);
      }
    }, 60000);
  }

  // ─── OPEN & CONTINUE ───────────────────────────────
  handleOpenContinue = () => {
    const { lockerData, qrToken } = this.state;

    this.setState({ isOpening: true, showOpenOptions: false });
    this.startOpenCountdown();

    this.props.postTimeOpen({
      bleName: lockerData.BLEName,
      qrToken,
    })
    .then((answer) => {
      this.pollOpenStatus(answer.response.openingId, (success) => {
        if (success) {
          this.setState({ isOpening: false, isOpened: true });
        } else {
          this.setState({ isOpening: false, openError: true });
        }
      });
    })
    .catch(() => {
      this.setState({ isOpening: false, openError: true });
    });
  }

  // ─── OPEN & FINALIZE ───────────────────────────────
  handleOpenFinalize = () => {
    const { machineData, lockerData, qrToken } = this.state;

    this.setState({ isFinalizing: true, showOpenOptions: false });
    this.startOpenCountdown();

    this.props.postTimeOpen({
      bleName: lockerData.BLEName,
      qrToken,
    })
    .then((answer) => {
      this.pollOpenStatus(answer.response.openingId, (success) => {
        if (success) {
          // Door opened — now clear the rental
          this.props.postTimeFinalize({
            machineId: machineData._id,
            lockerIndex: lockerData.index,
            bleName: lockerData.BLEName,
          })
          .then(() => {
            this.setState({ isFinalizing: false, isFinalized: true });
          })
          .catch(() => {
            this.setState({ isFinalizing: false, openError: true });
          });
        } else {
          this.setState({ isFinalizing: false, openError: true });
        }
      });
    })
    .catch(() => {
      this.setState({ isFinalizing: false, openError: true });
    });
  }

  handleExit = () => {
    const { qrToken } = this.state;
    history.push(`/qrsale/${qrToken}`);
  }

  // ─── BUY MORE TIME ─────────────────────────────────
  toggleExtendModal = () => {
    const timeConfig = this.state.timeConfig || {};
    const slots = timeConfig.timeSlots || [60, 120, 240];
    this.setState(prev => ({
      showExtendModal: !prev.showExtendModal,
      extendSlotMinutes: prev.showExtendModal ? prev.extendSlotMinutes : slots[0],
      extendSuccess: false,
    }));
  }

  getExtendPrice() {
    const { lockerData, prices, timeConfig, extendSlotMinutes } = this.state;
    if (!lockerData || !prices || !prices.length || !extendSlotMinutes) return 0;
    const lockerKey = (lockerData.Mode || '') + (lockerData.Wide || '') + (lockerData.Type || '');
    const priceObj = prices.find(p => p.item === 'LOCKER' + lockerKey);
    const pricePerSlot = priceObj ? Number(priceObj.price) : 0;
    const minSlot = Math.min(...(timeConfig?.timeSlots || [60]));
    return pricePerSlot * (extendSlotMinutes / minSlot);
  }

  handleExtend = () => {
    const { lockerData, qrToken, extendSlotMinutes, qrType, lockerCustomerID, ticketIVA } = this.state;
    const additionalMinutes = extendSlotMinutes || 60;
    const extendPrice = this.getExtendPrice();
    const { i18n } = this.props;

    // FREE or zero price → direct extend without payment
    if (qrType === 'free' || extendPrice === 0) {
      this.setState({ isExtending: true });
      this.props.postTimeExtend({ bleName: lockerData.BLEName, additionalMinutes, qrToken })
        .then((answer) => {
          if (answer.response) {
            this.setState(prev => ({
              isExtending: false,
              extendSuccess: true,
              rentalData: { ...prev.rentalData, rentedMinutes: answer.response.newRentedTime },
              timeRemainingMinutes: prev.timeRemainingMinutes + additionalMinutes,
              isExpired: false,
            }));
          }
        })
        .catch(() => this.setState({ isExtending: false }));
      return;
    }

    // PAID: go through Redsys
    this.setState({ isExtending: true });

    const paymentId = Math.floor(Math.random() * 1000000 + 1).toString();
    const paymentDate = new Date().toISOString();

    // Save current view state to sessionStorage so the callback can restore it
    const EXTEND_KEY = 'vacway_time_extend_pending';
    sessionStorage.setItem(EXTEND_KEY, JSON.stringify({
      lockerData: this.state.lockerData,
      rentalData: this.state.rentalData,
      machineData: this.state.machineData,
      timeConfig: this.state.timeConfig,
      pricing: { qrType, ticketIVA, lockerCustomerID, prices: this.state.prices },
      phoneNumber: this.state.phoneNumber,
      accessCode: this.state.accessCode,
      qrToken,
      timeRemainingMinutes: this.state.timeRemainingMinutes,
    }));

    let language = '001';
    switch (i18n.language) {
      case 'es': language = '001'; break;
      case 'en': language = '002'; break;
      case 'it': language = '007'; break;
      case 'de': language = '005'; break;
      case 'fr': language = '004'; break;
      case 'pt': language = '009'; break;
      default: language = '002'; break;
    }

    const callbackParams = `bleName=${encodeURIComponent(lockerData.BLEName)}&additionalMinutes=${additionalMinutes}&qrToken=${qrToken}&paymentId=${paymentId}&paymentDate=${encodeURIComponent(paymentDate)}`;
    const redsysURLOK = `https://lockers-qr.vacway.es/extendTimeCallbackView?${callbackParams}`;
    const redsysURLKO = `https://lockers-qr.vacway.es/timeAccessView/${qrToken}`;

    let redsysPetition = {
      price: extendPrice,
      redsysURLOK,
      redsysURLKO,
      paymentId,
      merchantCode: '351639505',
      currency: '978',
      terminal: '1',
      merchantUrl: 'https://vacway.com',
      secretKey: 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM',
      language,
    };

    this.props.fetchCustomer(lockerCustomerID)
      .then((customer) => {
        if (customer.response?.Redsys) {
          redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE;
          redsysPetition.currency = customer.response.Redsys.CURRENCY;
          redsysPetition.terminal = customer.response.Redsys.TERMINAL;
          redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL;
          redsysPetition.secretKey = customer.response.Redsys.SECRETKEY;
        }
        return this.props.postRedsys(redsysPetition);
      })
      .then((answer) => {
        const answerRedsys = answer.response;
        this.setState({
          redsysSignature: answerRedsys.Ds_Signature,
          redsysMerchant: answerRedsys.Ds_MerchantParameters,
          redsysVersion: answerRedsys.Ds_SignatureVersion,
          redsysAction: qrType === 'test'
            ? 'https://sis-t.redsys.es:25443/sis/realizarPago'
            : 'https://sis.redsys.es/sis/realizarPago',
          isExtending: false,
        }, () => {
          this.redsysFormRef.current?.submit();
        });
      })
      .catch(() => {
        sessionStorage.removeItem(EXTEND_KEY);
        this.setState({ isExtending: false });
      });
  }

  render() {
    const { t } = this.props;
    const {
      lockerData, rentalData, timeRemainingMinutes, isExpired,
      showOpenOptions, isOpening, isOpened, openError,
      isFinalizing, isFinalized,
      showExtendModal, extendSlotMinutes, isExtending, extendSuccess,
      minutes, seconds,
      qrType, redsysSignature, redsysMerchant, redsysVersion, redsysAction,
    } = this.state;

    const primaryColor = this.getPrimaryColor();
    const buttonStyle = this.getButtonStyle();

    if (!lockerData || !rentalData) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-center">
              <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
            </div>
          </div>
        </div>
      );
    }

    // ─── FINALIZED SCREEN ─────────────────────────────
    if (isFinalized) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-locker-selector-wide">
              <div className="time-page-header">
                <div className="time-page-header-icon" style={{ background: '#27ae60', border: 'none', color: '#fff' }}>✓</div>
                <div className="time-page-header-text">
                  <h2>{t('¡Gracias por usar nuestro servicio!')}</h2>
                  <p>{t('Tu taquilla ha sido liberada correctamente. Recuerda retirar todas tus pertenencias.')}</p>
                </div>
              </div>
              <div className="time-phone-card" style={{ textAlign: 'center' }}>
                <button className="time-continue-btn" style={buttonStyle} onClick={this.handleExit}>
                  {t('SALIR')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // ─── OPENED (Continue) SCREEN ─────────────────────
    if (isOpened) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-locker-selector-wide">
              <div className="time-page-header">
                <div className="time-page-header-icon" style={{ background: '#27ae60', border: 'none', color: '#fff' }}>✓</div>
                <div className="time-page-header-text">
                  <h2>{t('¡Taquilla abierta!')}</h2>
                  <p>{t('Tu taquilla está abierta. Ciérrala cuando termines.')}</p>
                </div>
              </div>
              <div className="time-phone-card" style={{ textAlign: 'center' }}>
                <img src="/images/lockerOpen.png" alt="Open" className="time-modal-img" />
                <p className="time-time-remaining" style={{ marginTop: '12px' }}>
                  {t('Tiempo restante:')} <strong style={{ color: primaryColor }}>{this.formatTimeRemaining()}</strong>
                </p>
                <button className="time-continue-btn" style={{ ...buttonStyle, marginTop: '16px' }} onClick={this.handleExit}>
                  {t('FINALIZAR SESIÓN')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // ─── OPENING/FINALIZING IN PROGRESS ───────────────
    if (isOpening || isFinalizing) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-locker-selector-wide">
              <div className="time-page-header">
                <div className="time-page-header-icon" style={buttonStyle}>
                  <LockKeyhole size={24} strokeWidth={2} />
                </div>
                <div className="time-page-header-text">
                  <h2>{isFinalizing ? t('Abriendo y liberando taquilla') : t('Abriendo taquilla')}</h2>
                  <p>{t('Por favor, mantente cerca de tu taquilla.')}</p>
                </div>
              </div>
              <div className="time-phone-card" style={{ textAlign: 'center' }}>
                <div className="time-countdown" style={{ color: primaryColor }}>
                  {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
                </div>
                <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // ─── ERROR SCREEN ────────────────────────────────
    if (openError) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-locker-selector-wide">
              <div className="time-page-header">
                <div className="time-page-header-icon" style={{ background: '#e74c3c', border: 'none', color: '#fff' }}>✕</div>
                <div className="time-page-header-text">
                  <h2>{t('Error al abrir la taquilla')}</h2>
                  <p>{t('No se ha podido abrir la taquilla. Inténtalo de nuevo.')}</p>
                </div>
              </div>
              <div className="time-phone-card" style={{ textAlign: 'center' }}>
                <button className="time-continue-btn" style={buttonStyle} onClick={() => this.setState({ openError: false })}>
                  {t('REINTENTAR')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // ─── MAIN VIEW: LOCKER INFO + ACTIONS ─────────────
    const timeProgressPercent = rentalData.totalMinutes > 0
      ? Math.max(0, Math.min(100, (timeRemainingMinutes / rentalData.totalMinutes) * 100))
      : 0;

    const progressColor = isExpired ? '#e74c3c' : timeRemainingMinutes <= 15 ? '#f39c12' : '#27ae60';

    const rentStart = rentalData.rentStartTime ? new Date(rentalData.rentStartTime) : null;
    const expiryTime = rentalData.expiryTime ? new Date(rentalData.expiryTime) : null;
    const formatTime = (d) => d ? d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) : '—';
    const formatDate = (d) => d ? d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—';

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={buttonStyle}>
                <LockKeyhole size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('Tu taquilla')}</h2>
                <p>{t('Gestiona tu alquiler y accede a tu taquilla')}</p>
              </div>
            </div>

            <div className="time-phone-cols">

              {/* ── LEFT: info cards ── */}
              <div className="time-phone-col-left">

                {/* Locker identity */}
                <div className="time-phone-card" style={{ borderTop: `4px solid ${primaryColor}` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px' }}>
                    <div style={{
                      width: 52, height: 52, borderRadius: 12,
                      background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}cc)`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}>
                      <LockKeyhole size={26} color="#fff" strokeWidth={2} />
                    </div>
                    <div>
                      <div style={{ fontSize: '0.75rem', color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{t('Número de taquilla')}</div>
                      <div style={{ fontSize: '2.2rem', fontWeight: 800, color: primaryColor, lineHeight: 1.1 }}>
                        {Number(lockerData.Matricula) + Number(lockerData.FirstIndex) - 1}
                      </div>
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                      <span style={{
                        background: primaryColor, color: '#fff', padding: '4px 12px',
                        borderRadius: 20, fontWeight: 700, fontSize: '0.85rem'
                      }}>{lockerData.Type}</span>
                      <span style={{
                        background: isExpired ? '#fdf0f0' : '#f0faf4',
                        color: isExpired ? '#e74c3c' : '#27ae60',
                        border: `1px solid ${isExpired ? '#e74c3c' : '#27ae60'}`,
                        padding: '3px 10px', borderRadius: 20, fontWeight: 600, fontSize: '0.75rem'
                      }}>{isExpired ? t('EXPIRADO') : t('ACTIVO')}</span>
                    </div>
                  </div>

                  {/* Customer credentials */}
                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{
                      flex: 1, background: '#f8f9fa', borderRadius: 10, padding: '10px 14px',
                      display: 'flex', alignItems: 'center', gap: 10
                    }}>
                      <Phone size={16} color={primaryColor} strokeWidth={2} />
                      <div>
                        <div style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600, textTransform: 'uppercase' }}>{t('Teléfono')}</div>
                        <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#333' }}>+{this.state.phoneNumber}</div>
                      </div>
                    </div>
                    <div style={{
                      flex: 1, background: '#f8f9fa', borderRadius: 10, padding: '10px 14px',
                      display: 'flex', alignItems: 'center', gap: 10
                    }}>
                      <KeyRound size={16} color={primaryColor} strokeWidth={2} />
                      <div>
                        <div style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600, textTransform: 'uppercase' }}>{t('Código')}</div>
                        <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#333', letterSpacing: 3 }}>{this.state.accessCode}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Time card */}
                <div className="time-phone-card" style={{ borderTop: `4px solid ${progressColor}` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                    <Timer size={18} color={progressColor} strokeWidth={2} />
                    <span style={{ fontWeight: 700, color: '#333', fontSize: '0.95rem' }}>{t('Tiempo de alquiler')}</span>
                  </div>

                  <div className="time-time-progress-bar">
                    <div className="time-time-progress-fill"
                      style={{ width: `${timeProgressPercent}%`, background: progressColor }}></div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600, textTransform: 'uppercase' }}>{t('Alquilado')}</div>
                      <div style={{ fontWeight: 700, fontSize: '1rem', color: '#333' }}>{this.formatRentedTime()}</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600, textTransform: 'uppercase' }}>{t('Restante')}</div>
                      <div style={{ fontWeight: 800, fontSize: '1.1rem', color: isExpired ? '#e74c3c' : progressColor }}>
                        {isExpired ? t('EXPIRADO') : this.formatTimeRemaining()}
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '0.7rem', color: '#999', fontWeight: 600, textTransform: 'uppercase' }}>{t('Cortesía')}</div>
                      <div style={{ fontWeight: 700, fontSize: '1rem', color: '#333' }}>+{rentalData.courtesyTime} min</div>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 10 }}>
                    <div style={{ flex: 1, background: '#f8f9fa', borderRadius: 10, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <CalendarClock size={15} color="#999" strokeWidth={2} />
                      <div>
                        <div style={{ fontSize: '0.68rem', color: '#999', textTransform: 'uppercase', fontWeight: 600 }}>{t('Inicio')}</div>
                        <div style={{ fontSize: '0.82rem', fontWeight: 700, color: '#333' }}>{formatDate(rentStart)} {formatTime(rentStart)}</div>
                      </div>
                    </div>
                    <div style={{ flex: 1, background: '#f8f9fa', borderRadius: 10, padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Clock size={15} color="#999" strokeWidth={2} />
                      <div>
                        <div style={{ fontSize: '0.68rem', color: '#999', textTransform: 'uppercase', fontWeight: 600 }}>{t('Fin')}</div>
                        <div style={{ fontSize: '0.82rem', fontWeight: 700, color: isExpired ? '#e74c3c' : '#333' }}>{formatDate(expiryTime)} {formatTime(expiryTime)}</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* ── RIGHT: actions ── */}
              <div className="time-phone-col-right">
                <div className="time-phone-card" style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}>

                  {isExpired && (
                    <div style={{
                      background: '#fdf0f0', border: '1px solid #e74c3c', borderRadius: 10,
                      padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 10
                    }}>
                      <span style={{ fontSize: '1.2rem' }}>⚠️</span>
                      <p style={{ margin: 0, color: '#c0392b', fontSize: '0.85rem', fontWeight: 600 }}>
                        {t('Tu tiempo ha expirado. Abre para retirar tus pertenencias.')}
                      </p>
                    </div>
                  )}

                  {/* Open action */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <LockKeyholeOpen size={16} color={primaryColor} strokeWidth={2} />
                      <span style={{ fontWeight: 700, fontSize: '0.82rem', color: primaryColor, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                        {t('Acceso a taquilla')}
                      </span>
                    </div>
                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#888', lineHeight: 1.4 }}>
                      {!isExpired
                        ? t('Pulsa para abrir tu taquilla. Podrás elegir si continuar el alquiler o finalizarlo.')
                        : t('Tu tiempo ha terminado. Abre para retirar tus objetos y liberar la taquilla.')}
                    </p>
                    {!isExpired ? (
                      <button
                        className="time-continue-btn"
                        style={{ ...buttonStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontSize: '1rem', padding: '14px', marginTop: 0 }}
                        onClick={() => this.setState({ showOpenOptions: true })}
                      >
                        <LockKeyholeOpen size={20} strokeWidth={2} />
                        {t('ABRIR TAQUILLA')}
                      </button>
                    ) : (
                      <button
                        className="time-action-btn time-btn-finalize"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontSize: '1rem', padding: '14px' }}
                        onClick={this.handleOpenFinalize}
                      >
                        <LockKeyholeOpen size={20} strokeWidth={2} />
                        {t('ABRIR Y FINALIZAR')}
                      </button>
                    )}
                  </div>

                  <div style={{ borderTop: '1px solid #f0f0f0' }} />

                  {/* Extend action */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Clock size={16} color={primaryColor} strokeWidth={2} />
                      <span style={{ fontWeight: 700, fontSize: '0.82rem', color: primaryColor, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                        {t('Ampliar tiempo')}
                      </span>
                    </div>
                    <p style={{ margin: 0, fontSize: '0.8rem', color: '#888', lineHeight: 1.4 }}>
                      {t('¿Necesitas más tiempo? Añade horas adicionales a tu alquiler actual sin perder el acceso.')}
                    </p>
                    <button
                      className="time-action-btn time-btn-extend"
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontSize: '1rem', padding: '14px' }}
                      onClick={this.toggleExtendModal}
                    >
                      <Clock size={20} strokeWidth={2} />
                      {t('COMPRAR MÁS TIEMPO')}
                    </button>
                  </div>

                  <div style={{ borderTop: '1px solid #f0f0f0' }} />

                  {/* Volver */}
                  <button
                    className="time-continue-btn"
                    style={{ background: 'none', border: `2px solid ${primaryColor}`, color: primaryColor }}
                    onClick={this.handleExit}
                  >
                    {t('Salir')}
                  </button>

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ── Open Options Modal ── */}
        <Modal isOpen={showOpenOptions} toggle={() => this.setState({ showOpenOptions: false })}>
          <ModalBody className="time-modal" style={{ padding: '28px 24px' }}>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{
                width: 56, height: 56, borderRadius: 16, background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}cc)`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
              }}>
                <LockKeyholeOpen size={28} color="#fff" strokeWidth={2} />
              </div>
              <h4 style={{ fontWeight: 700, color: '#333', marginBottom: 4 }}>{t('¿Cómo deseas abrir?')}</h4>
              <p style={{ color: '#999', fontSize: '0.85rem', margin: 0 }}>{t('Elige una opción para continuar')}</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 14 }}>
              <button
                onClick={this.handleOpenContinue}
                style={{
                  display: 'flex', alignItems: 'center', gap: 16, padding: '18px 20px',
                  borderRadius: 14, border: `2px solid ${primaryColor}`,
                  background: `linear-gradient(135deg, ${primaryColor}08, ${primaryColor}18)`,
                  cursor: 'pointer', textAlign: 'left', transition: 'transform 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={{
                  width: 44, height: 44, borderRadius: 12, background: primaryColor,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <LockKeyholeOpen size={22} color="#fff" strokeWidth={2} />
                </div>
                <div>
                  <div style={{ fontWeight: 800, color: primaryColor, fontSize: '0.95rem' }}>{t('ABRIR Y CONTINUAR')}</div>
                  <div style={{ color: '#888', fontSize: '0.8rem', marginTop: 2 }}>{t('La taquilla seguirá alquilada a tu nombre')}</div>
                </div>
              </button>

              <button
                onClick={this.handleOpenFinalize}
                style={{
                  display: 'flex', alignItems: 'center', gap: 16, padding: '18px 20px',
                  borderRadius: 14, border: '2px solid #e74c3c',
                  background: '#fdf0f0',
                  cursor: 'pointer', textAlign: 'left', transition: 'transform 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={{
                  width: 44, height: 44, borderRadius: 12, background: '#e74c3c',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <LogOut size={22} color="#fff" strokeWidth={2} />
                </div>
                <div>
                  <div style={{ fontWeight: 800, color: '#e74c3c', fontSize: '0.95rem' }}>{t('ABRIR Y FINALIZAR')}</div>
                  <div style={{ color: '#888', fontSize: '0.8rem', marginTop: 2 }}>{t('Se liberará la taquilla al abrirla')}</div>
                </div>
              </button>
            </div>

            <button
              style={{
                width: '100%', padding: '12px', borderRadius: 10, border: '1px solid #ddd',
                background: '#f5f5f5', color: '#888', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem',
              }}
              onClick={() => this.setState({ showOpenOptions: false })}
            >
              {t('CANCELAR')}
            </button>
          </ModalBody>
        </Modal>

        {/* ── Extend Time Modal ── */}
        <Modal isOpen={showExtendModal} toggle={this.toggleExtendModal}>
          <ModalBody className="text-center time-modal">
            {extendSuccess ? (
              <div>
                <div className="time-modal-icon time-success">✓</div>
                <h3>{t('¡Tiempo ampliado!')}</h3>
                <p>{t('Se han añadido')} {this.formatExtendDuration(extendSlotMinutes)} {t('a tu alquiler.')}</p>
                <button className="time-modal-btn" style={buttonStyle} onClick={this.toggleExtendModal}>
                  {t('ACEPTAR')}
                </button>
              </div>
            ) : (
              <div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{
                    width: 50, height: 50, borderRadius: 14, background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}cc)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px',
                  }}>
                    <Clock size={24} color="#fff" strokeWidth={2} />
                  </div>
                  <h4 style={{ fontWeight: 700, marginBottom: 4 }}>{t('Ampliar tiempo')}</h4>
                  <p style={{ color: '#999', fontSize: '0.85rem', margin: 0 }}>{t('Selecciona cuánto tiempo adicional necesitas')}</p>
                </div>
                {/* Preset slots */}
                <div className="time-time-slots" style={{ marginBottom: 12 }}>
                  {(this.state.timeConfig?.timeSlots || [60, 120, 240]).map(minutes => {
                    const { prices, timeConfig: tc } = this.state;
                    const { lockerData: ld } = this.state;
                    let slotPrice = 0;
                    if (prices && prices.length && ld) {
                      const key = (ld.Mode || '') + (ld.Wide || '') + (ld.Type || '');
                      const po = prices.find(p => p.item === 'LOCKER' + key);
                      const pps = po ? Number(po.price) : 0;
                      const ms = Math.min(...((tc?.timeSlots) || [60]));
                      slotPrice = pps * (minutes / ms);
                    }
                    const isActive = extendSlotMinutes === minutes;
                    return (
                      <button
                        key={minutes}
                        className={`time-time-slot ${isActive ? 'time-time-slot-active' : ''}`}
                        style={isActive ? { background: primaryColor, color: '#fff', borderColor: primaryColor } : {}}
                        onClick={() => this.setState({ extendSlotMinutes: minutes })}
                      >
                        <span style={{ display: 'block', fontWeight: 600, lineHeight: 1.2 }}>{this.formatExtendDuration(minutes)}</span>
                        {slotPrice > 0 && (
                          <span style={{ display: 'block', fontSize: '0.75rem', opacity: 0.85, marginTop: 2 }}>{slotPrice.toFixed(2)} €</span>
                        )}
                      </button>
                    );
                  })}
                </div>
                {/* Stepper */}
                <div className="time-qty-controls">
                  <button className="time-qty-btn"
                    onClick={() => {
                      const minSlot = Math.min(...(this.state.timeConfig?.timeSlots || [60]));
                      const maxSlot = minSlot * (this.state.timeConfig?.maxSlots || 8);
                      this.setState(prev => ({ extendSlotMinutes: Math.max(minSlot, (prev.extendSlotMinutes || minSlot) - minSlot) }));
                    }}>−</button>
                  <span className="time-qty-value">
                    <span style={{ display: 'block', lineHeight: 1.2 }}>{this.formatExtendDuration(extendSlotMinutes)}</span>
                    {this.getExtendPrice() > 0 && (
                      <span style={{ display: 'block', fontSize: '0.8rem', color: primaryColor, fontWeight: 700 }}>{this.getExtendPrice().toFixed(2)} €</span>
                    )}
                  </span>
                  <button className="time-qty-btn"
                    onClick={() => {
                      const minSlot = Math.min(...(this.state.timeConfig?.timeSlots || [60]));
                      const maxSlot = minSlot * (this.state.timeConfig?.maxSlots || 8);
                      this.setState(prev => ({ extendSlotMinutes: Math.min(maxSlot, (prev.extendSlotMinutes || minSlot) + minSlot) }));
                    }}>+</button>
                </div>
                {/* Price summary */}
                {(() => {
                  const extendPrice = this.getExtendPrice();
                  if (extendPrice > 0) {
                    return (
                      <div style={{ background: '#f8f9fa', borderRadius: 10, padding: '10px 14px', margin: '12px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ color: '#666', fontSize: '0.9rem' }}>{t('Total a pagar')}</span>
                        <strong style={{ color: primaryColor, fontSize: '1.2rem' }}>{extendPrice.toFixed(2)} €</strong>
                      </div>
                    );
                  }
                  return null;
                })()}
                <button className="time-modal-btn" style={{ ...buttonStyle, marginTop: 16 }}
                  onClick={this.handleExtend} disabled={isExtending}>
                  {isExtending ? (
                    <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                  ) : qrType === 'free' || this.getExtendPrice() === 0 ? t('AMPLIAR TIEMPO') : t('PAGAR Y AMPLIAR')}
                </button>
                <button className="time-modal-btn time-btn-cancel" onClick={this.toggleExtendModal}>
                  {t('CANCELAR')}
                </button>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* ── Redsys hidden form for extend payment ── */}
        {redsysSignature && (
          <form ref={this.redsysFormRef} action={redsysAction} method="POST" style={{ display: 'none' }}>
            <input type="hidden" name="Ds_SignatureVersion" value={redsysVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
            <input type="hidden" name="Ds_Signature" value={redsysSignature} />
          </form>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postTimeOpen: bindActionCreators(postTimeOpen, dispatch),
  fetchTimeOpenStatus: bindActionCreators(fetchTimeOpenStatus, dispatch),
  postTimeFinalize: bindActionCreators(postTimeFinalize, dispatch),
  postTimeExtend: bindActionCreators(postTimeExtend, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(TimeOpenView));
